module.exports = __webpack_public_path__ + "img/huilv.c610b015.png";